// DEPLOY-PROBE-bump

/**
 * Canonical construction site (現場) name: NFKC + trim.
 * Maps full-width digits (１) to half-width (1), etc.
 */
export function normalizeGenbaName(genba: string | null | undefined): string {
  if (genba == null) return '';
  return genba.normalize('NFKC').trim();
}

export function sameGenba(a: string | null | undefined, b: string | null | undefined): boolean {
  return normalizeGenbaName(a) === normalizeGenbaName(b);
}
